import parse from 'html-react-parser';
import { parseMarginPadding, parseResult } from '../controlUtils';

export function displayTitleUtil(obj, entryPoint){

    const content = JSON.parse(obj.Content);
    const title = parse(content.Title);
    const theme = content.Theme;
    const size = content.Size;
    const marginPadding = content.MarginPadding;

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    const mp = parseMarginPadding(marginPadding);
    
    let titleSz = 0; let zoom = 0;
    if(size == "small"){ titleSz=18;}
    else if(size == "medium"){ titleSz=24; }
    else if(size == "large"){ titleSz=28; }
    
    if(entryPoint == "presentation" && obj.Presentation != ""){
        const ptn = JSON.parse(obj.Presentation);
        if(ptn.TitleSize != "") { titleSz = parseInt(ptn.TitleSize) }
        if(ptn.Zoom != "") { zoom = parseInt(ptn.Zoom) }
    }

    const styles = {
        title:{
            background: bgColor,
            color: txtColor,
            fontSize: titleSz,
            zoom: `${zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
        }
    }

    let display = <></>;

    if(size == "large"){ 
        display = <h2 className="title-large" style={styles.title}>{title}</h2> 
    }
    else if(size == "medium"){ 
        display = <h3 className="title-medium" style={styles.title}>{title}</h3>
    }
    else if(size == "small"){ 
        display = <h4 className="title-small" style={styles.title}>{title}</h4>
    }

    const elem = <div className={"title"}>{display}</div>;
    return parseResult(elem, obj, entryPoint);

}